import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Navbar, PrivacyPolicy, TermsnConditions, Disclaimer, ShippingandDelivery, ReturnPolicy, Error404, 
        Home, Aboutus, Contactus, ProfileEdit,
        MarketPlace,GoldBuyingDaily,Verifyupi,SubmitAuthReq,
        GoldBuyingWeekly, Verifyupi_Weekly, SubmitAuthReq_Weekly,
        GoldBuyingMonthly, Verifyupi_Monthly, SubmitAuthReq_Monthly,
        GoldBuying } from './routes/Routes';
import Store from './routes/Store/Store';
import AndroidStore from './routes/Store/AndroidStore';
import GoldCoins from "./routes/Store/GoldCoins";
import GoldNuggets from "./routes/Store/GoldNuggets/GoldNuggets"
import Cart from './routes/Store/Cart';
import Checkout from './routes/Store/Checkout'
import DirectPayment from './routes/Store/Payment/DirectPayment'
import ReferralStore from './routes/Store/ReferralStore'
import GoldSmelter from './routes/Store/GoldSmelter/GoldSmelter'
import StatusCheck from './routes/MarketPlace/StatusCheck'
import UserCurrencySummery from './routes/user/UserCurrencySummery'
import Signin from './routes/auth/Signin';
import Register from './routes/auth/register';
import ForgotPassword from './routes/auth/ForgotPassword'
import { useAuth } from './hooks/GlobalProvider';
import Dashboard from "./routes/user/Dashboard";
import PaymentHistory from './routes/user/PaymentHistory';
import Invoice from './routes/Invoice'
import LogoLoader from "./routes/LogoLoader";

const CACHE_KEY = 'cart';
const LAST_CLEAN_KEY = 'lastCacheClean';

const App = () => {
  const location = useLocation();
  const { user, loading } = useAuth();
  
  const [cart, setCart] = useState([]);

  // Auto cache clean function
  const clearCacheIfNeeded = () => {
    const lastClean = localStorage.getItem(LAST_CLEAN_KEY);
    const now = Date.now();
    const ONE_HOUR = 1000 * 60 * 60; // 1 hour in milliseconds

    if (!lastClean || now - parseInt(lastClean) > ONE_HOUR) {
      localStorage.removeItem(CACHE_KEY); // remove cached cart
      localStorage.setItem(LAST_CLEAN_KEY, now.toString());
      setCart([]);
      console.log("Cache cleared automatically");
    }
  }

  useEffect(() => {
    clearCacheIfNeeded(); // check on app load

    const savedCart = JSON.parse(localStorage.getItem(CACHE_KEY)) || [];
    setCart(savedCart);

    // Set interval to check every hour
    const interval = setInterval(() => {
      clearCacheIfNeeded();
    }, 1000 * 60 * 60);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cart));
  }, [cart]);

  if (loading) {
    return <LogoLoader/>
  }

  const hideNavbar = 
    location.pathname === '/Store/checkout' || 
    location.pathname === '/AndroidStore' || 
    location.pathname === '/Store/checkout/DirectPayment';

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsconditions" element={<TermsnConditions />} />
        <Route path="/returnpolicy" element={<ReturnPolicy />} />
        <Route path="/shippingdelivery" element={<ShippingandDelivery />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/user/dashboard" element={<Dashboard />} />
        <Route path="/user/paymenthistory" element={<PaymentHistory />} />
        <Route path="/user/profileedit" element={<ProfileEdit />} />
        <Route path="/user/currency" element={user ? <UserCurrencySummery /> : <Navigate to="/signin" />} />
        <Route path="/invoice" element={<Invoice />} />

        <Route path="/MarketPlace" element={<MarketPlace />} />
        <Route path="/MarketPlace/gold-buying" element={user ? <GoldBuying /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/StatusCheck" element={user ? <StatusCheck /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/gold-buying-daily" element={user ? <GoldBuyingDaily /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/Daily/verifyupi" element={user ? <Verifyupi /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/Daily/submit-auth-req" element={user ? <SubmitAuthReq /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/gold-buying-weekly" element={user ? <GoldBuyingWeekly /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/Weekly/verifyupi" element={user ? <Verifyupi_Weekly /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/Weekly/submit-auth-req" element={user ? <SubmitAuthReq_Weekly /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/gold-buying-monthly" element={user ? <GoldBuyingMonthly /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/Monthly/verifyupi" element={user ? <Verifyupi_Monthly /> : <Navigate to="/signin" />} />
        <Route path="/MarketPlace/Monthly/submit-auth-req" element={user ? <SubmitAuthReq_Monthly /> : <Navigate to="/signin" />} />

        <Route path="/Store" element={<Store />} />
        <Route path="/AndroidStore" element={<AndroidStore />} />
        <Route path="/Store/GoldCoins" element={user ? <GoldCoins /> : <Navigate to="/signin" />} />
        <Route path="/Store/GoldNuggets" element={user ? <GoldNuggets /> : <Navigate to="/signin" />} />
        <Route path="/Store/cart" element={user ? <Cart /> : <Navigate to="/signin" />} />
        <Route path="/Store/checkout" element={user ? <Checkout /> : <Navigate to="/signin" />} />
        <Route path="/Store/checkout/DirectPayment" element={user ? <DirectPayment /> : <Navigate to="/signin" />} />
        <Route path="/Store/referralstore" element={user ? <ReferralStore /> : <Navigate to="/signin" />} />
        <Route path="/Store/goldsmelter" element={user ? <GoldSmelter /> : <Navigate to="/signin" />} />
        <Route path="/*" element={<Error404 />} />
      </Routes>
    </>
  );
};

export default App;
